import { LegacyResponseFieldDataType, PaymentTokenResponseType } from './types';

export const transformLegacyPaymentTokenResponse = (
  data: LegacyResponseFieldDataType
): PaymentTokenResponseType => {
  const paymentTokenField = data.field_data?.find(
    (f) => f.field_id === 'payment_token'
  );
  return {
    paymentToken: paymentTokenField?.value,
    errors: paymentTokenField?.errors,
  };
};
